var event;
i18next.use(window.i18nextXHRBackend);
i18next.init({
    debug: isDebug,
    keySeparator: '_',
    backend: {
        loadPath: '/umbraco/backoffice/api/dictionary/getresources?lng=' + lng,
        crossDomain: true
    }
}, function (err, t) {

    startApplication();
    //Message Ce site utilise des cookies.
    FCook();
    translateErrors();
});



function bookingNumber() {
    return function (input) {
        return input.replace(/^0+/, '');
    };
}

webClient.filter('bookingNumber', bookingNumber);

function unique() {

    return function (input, property) {

        if (typeof input === 'undefined') {
            return input;
        }

        var map = new Map();
        var result = [];
        for (var i = 0; i < input.length; i++) {
            if (!map.has(input[i][property])) {
                map.set(input[i][property], true);
                result.push(input[i]);
            }
        }
        return result;
    };
}

webClient.filter('unique', unique);

function productType() {
    return function (input, product, bypass) {
        if (input) {

            if (bypass === true) {
                return input;
            }

            if (product === 'flight') {
                return input.filter(function (b) { return !(b.accommodations && b.accommodations.length > 0 || b.bookingAccommodationId !== null); });
            }
            else if (product === 'basket') {
                return input.filter(function (b) { return b.accommodations && b.accommodations.length > 0 || b.bookingAccommodationId !== null; });
            }
            else {
                return input;
            }
        }
    };
}

webClient.filter('productType', productType);


function startApplication() {

    angular.element(document).ready(function () {
        angular.bootstrap(document, ["webClient"]);
        if ($('mrfly-widget-newsletter').length > 0) {
            $.getScript("/Global/js/widgets/mrfly-widget-newsletter.js");
        }

        if ($('#search-engine-widget').length > 0) {
            $.getScript("/Global/js/widgets/mrfly-widget-search-engine.js").done(function () {
                $("#misterflySite").trigger("widgetVolLoaded");
            });
        }

    });
}

